/* Glowee PDP runtime tweaks — inject custom rating row after title.
   Scoped to body.template-suffix-grape-bubblegum (test product) for now. */
(function () {
  if (!document.body.classList.contains('template-suffix-grape-bubblegum')) return;

  function injectRating() {
    if (document.querySelector('.gw-pdp-rating')) return;
    var titleEl = document.querySelector('.hdt-product-title');
    if (!titleEl) return;

    var rating = document.createElement('div');
    rating.className = 'gw-pdp-rating';
    rating.innerHTML =
      '<span class="gw-pdp-rating__stars" aria-hidden="true">★★★★★</span>' +
      ' <span class="gw-pdp-rating__score">4,9</span>' +
      ' <span class="gw-pdp-rating__sep">·</span>' +
      ' <a class="gw-pdp-rating__count" href="#recenze">827 recenzí</a>';

    titleEl.insertAdjacentElement('afterend', rating);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectRating);
  } else {
    injectRating();
  }
})();

/* ── Dynamic checkout (Apple Pay / Google Pay / "Koupit teď") fix ──
   The theme's King product-form handling intercepts the form submit, so the
   wallet button never adds the clicked product — it checks out whatever is
   already in the cart (empty cart → bounce to homepage). The wallet renders as
   a <shopify-accelerated-checkout> web component with a CLOSED shadow root, so
   its internal handler is unreachable. click is a composed event, so a capture
   listener on the host fires before the inner shadow handler: we intercept it,
   add the current product to the cart ourselves (bypassing King), then go to
   checkout — which now contains the right product. */
(function () {
  function bindWallet() {
    var form = document.querySelector('form.gpdp-form');
    if (!form) return;
    var wallet = form.querySelector('shopify-accelerated-checkout, .shopify-payment-button');
    if (!wallet || wallet.dataset.gwCheckoutBound) return;
    wallet.dataset.gwCheckoutBound = '1';
    wallet.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
        credentials: 'same-origin'
      })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindWallet);
  } else {
    bindWallet();
  }
  // The wallet web component can hydrate after load — keep trying briefly.
  var tries = 0;
  var iv = setInterval(function () {
    bindWallet();
    if (++tries > 24) clearInterval(iv);
  }, 250);
})();
